import {checkGeoLocation} from "./geolocation";
import {showMessage} from "./modals";
import {uniqueUserId} from "./fingerprint2";

$(document).on('click', '.js-add-like, .js-add-dislike', function (e) {
    e.preventDefault();
    checkGeoLocation();

    window.canLikeItem = -1;

    const checkHasAnswerInterval = setInterval(() => {

        try {
            if (canLikeItem !== -1) {

                clearInterval(checkHasAnswerInterval);

                if (!canLikeItem) {
                    throw new Error(window.jsLocalizations['cannot_rate_too_far']);
                }

                const parentEl = $(this).closest('.js-add-rate');
                if (parentEl.data('route') && parentEl.data('rateable-id')) {
                    const rateType = (($(this).hasClass('js-add-dislike') ? 'dis' : '') + 'like');
                    const sendData = {
                        'id': +parentEl.data('rateable-id'),
                        'type': rateType,
                        '_token': $('meta[name="csrf-token"]').attr('content'),
                        'uniqueUserId': uniqueUserId,
                        'categoryId': $('.dish').data('category-id'),
                    };
                    $.post(parentEl.data('route'), sendData, (ans) => {
                        if (ans.success) {
                            parentEl.find('.js-add-like, .js-add-dislike').removeClass('active');

                            const items = document.querySelectorAll('[data-created-today="true"]')
                            for(const item of Array.from(items)) {
                                if (
                                    (item.dataset?.uniqueUserId ?? null) === uniqueUserId ||
                                    item.dataset?.currentUser === 'true'
                                ) {
                                    $(item)
                                        .find('.like-comment-img, .dislike-comment-img, .default-comment-img')
                                        .addClass('d-none');

                                    if(ans.active) {
                                        $(item).find(`.${rateType}-comment-img`).removeClass('d-none');
                                    } else {
                                        $(item).find('.default-comment-img').removeClass('d-none');
                                    }

                                }
                            }

                            if (ans.active) {
                                $(this).addClass('active');
                                $(`[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .${($(this).hasClass('js-add-dislike') ? 'dis' : '')}like-comment-img`).removeClass('d-none');
                            } else {
                                $(this).removeClass('active');
                                $(`[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .default-comment-img`).removeClass('d-none');
                            }

                            /*$(`[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .like-comment-img,[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .dislike-comment-img, [data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .default-comment-img`).addClass('d-none');
                            if (ans.active) {
                                $(this).addClass('active');
                                $(`[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .${($(this).hasClass('js-add-dislike') ? 'dis' : '')}like-comment-img`).removeClass('d-none');
                            } else {
                                $(this).removeClass('active');
                                $(`[data-created-today="true"][data-unique-user-id="${uniqueUserId}"] .default-comment-img`).removeClass('d-none');
                            }*/
                            'likesCount' in ans && $('.js-likes-count').text(ans.likesCount);
                            'dislikesCount' in ans && $('.js-dislikes-count').text(ans.dislikesCount);
                            'ratesCount' in ans && $('.js-rates-count').text(ans.ratesCount);
                            'ratePercent' in ans && $('.js-rate-percent-title').text(ans.ratePercent + '%');
                            'ratePercent' in ans && $('.js-rate-percent-value').css('width', ans.ratePercent + '%').attr('aria-valuenow', ans.ratePercent);
                        } else {
                            showMessage(window.jsLocalizations[ans.error] || ans.error, false, false, 'error');
                            console.warn(window.jsLocalizations['error'] + ':', ans.error);
                        }
                    });
                }
            }

        } catch (e) {
            showMessage((window.jsLocalizations[e.message] || e.message), false, false, 'error');
        }
    }, 400);
})
